import { ShellIconCar } from '@zrsystem/ui';
import { createElement, lazy } from 'react';

import { formDrawerRegistry, type FormDrawerParams } from '@/app/surfaces/form-drawer-registry.js';

export const REGISTER_VEHICLE_DRAWER_KEY = 'register-vehicle';

function resolvePartyDisplayNameBadge(params: FormDrawerParams): string | undefined {
  const partyDisplayName = params['partyDisplayName'];
  if (typeof partyDisplayName !== 'string' || partyDisplayName.trim().length === 0) {
    return undefined;
  }

  return `para ${partyDisplayName.trim()}`;
}

formDrawerRegistry[REGISTER_VEHICLE_DRAWER_KEY] = {
  title: 'Adicionar veículo',
  size: 'md',
  icon: createElement(ShellIconCar, { size: 14 }),
  badge: resolvePartyDisplayNameBadge,
  component: lazy(async () => {
    const module = await import('@/features/vehicle/surfaces/register-vehicle.drawer.js');
    return { default: module.RegisterVehicleDrawer };
  }),
};
